import { useLayerWeightFormat } from "components/common/plan/layerEditor/useLayerWeightFormat";
import { useTenantData } from "contexts/tenant";
import { useFormatNumber } from "src/utils/formatNumber";

/** Formats masses stored in tenant mass units in the tenant's display unit. */
export const useDeltaWeightFormat = () => {
  const { default_mix_breakdown, small_mass_per_mass } = useTenantData();
  const massScaleFactor =
    default_mix_breakdown === "small_mass" ? small_mass_per_mass : 1;
  const { unitLabel, decimalPlaces } = useLayerWeightFormat(massScaleFactor);
  const formatNumber = useFormatNumber()(decimalPlaces);
  const weightInputStep = massScaleFactor > 1 ? 100 : 0.1;
  const formatWeight = (mass: number): string =>
    `${formatNumber(mass * massScaleFactor)} ${unitLabel}`;
  const formatSignedWeight = (mass: number): string =>
    `${mass < 0 ? "−" : "+"}${formatWeight(Math.abs(mass))}`;
  return {
    massScaleFactor,
    unitLabel,
    weightInputStep,
    formatWeight,
    formatSignedWeight,
  };
};
